export const apiPath = '/v2/facilities';
const actionType = 'V2_FACILITIES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
